import Container from "../../Container/Container";
import SectionTitle from "../../SectionTitle/SectionTitle";
import { partners } from "../../../Data/partnersData";

import "../../../Style/home/partners.css";

function Partners() {
  // Repeating 3 times ensures seamless infinite scrolling across all screen widths
  const track = [...partners, ...partners, ...partners];

  return (
    <section className="section section--tint section--sm partners">
      <Container>
        <SectionTitle
          eyebrow="Clients & Compliance"
          title="Trusted by industry-leading"
          highlight="global brands."
          align="center"
        />
      </Container>

      <div className="partners__marquee" role="list" aria-label="Client companies">
        <div className="partners__track">
          {track.map((partner, index) => (
            <div
              key={`${partner.id}-${index}`}
              className="badge-token"
              role="listitem"
              title={partner.name}
            >
              {/* 3D Glossy Raised Bezel Ring */}
              <div className="badge-token__rim">
                <div className="badge-token__groove">
                  <div className="badge-token__core">
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="badge-token__img"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
              <span className="badge-token__label">{partner.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Partners;